export default "__VITE_ASSET__Wdc5vs4v__"